import styled from "../../styled-components.js";
export var InlineGroup = styled.div.withConfig({
  displayName: "InlineGroup",
  componentId: "sc-4o5aq4-0"
})(["display:flex;flex-wrap:wrap;"]);